import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LegendItem } from "app/shared/data-interaction";
import { Helper } from "app/shared/helper";
import { Logger } from "app/shared/services/logger.service";
import { Chart } from "chart.js";

@Component({
  selector: "app-fuel-type-vehicles",
  templateUrl: "./fuel-type-vehicles.component.html",
  styleUrls: ["./fuel-type-vehicles.component.css"]
})
export class FuelTypeVehiclesComponent implements OnInit {
  @ViewChild("chartFuelVehicles") canvas;
  @Input() type;
  @Input() chart_id;
  @Input() options;
  @Input() indicator;
  @Input() sample_data;
  @Input() show_network_mix;
  @Input() hide_second_yaxis;
  @Input() chartData;
  @Input() value_type;
  @Input() unit;
  @Input() totals_in_tooltip; // true if we want to display the totals in the tooltip

  public areaChartLabels: number[];
  public fuelvehiclesData: any;
  private chart: Chart;
  private yAxes_def;
  private xAxes_def;
  private fuelvehiclesDatasets;
  private yAxeLabel_ind: string;
  private yAxeLabel_amount: string;
  private legendItems: LegendItem[] = [];
  private localOptions;
  private clickable = false; // Allows clicks on legend to change dataset displayed

  constructor(
    private logger: Logger,
    private helper: Helper,
    private translateService: TranslateService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.chartData) {
      this.localOptions = JSON.parse(JSON.stringify(this.options));
      this.createFuelvehiclesChart();
      this.updateLegend();
    }
  }

  getTranslatedLabel(labelToTranslate) {
    return this.translateService.instant("DATA." + labelToTranslate);
  }

  createFuelvehiclesChart() {
    this.resetChart();
    if (this.sample_data) {
      this.fuelvehiclesData = this.getSampleData();
    } else {
      let sum_instead_of_details = false;
      if (this.chartData) {
        this.fuelvehiclesData = {
          labels: this.chartData["vehicle_fuel_label"]
        };
        this.fuelvehiclesData["datasets"] = this.chartData["vehicle_fuel_data"];
        var i;
        for (i = 0; i < this.fuelvehiclesData["datasets"].length; i++) {
          this.fuelvehiclesData["datasets"][i][
            "label"
          ] = this.getTranslatedLabel(
            this.fuelvehiclesData["datasets"][i]["label"]
          );
          if (
            this.fuelvehiclesData["datasets"][i]["yAxisID"] == "ind" &&
            this.value_type != "pourcent" &&
            this.indicator == "energy"
          ) {
            var j;
            for (
              j = 0;
              j < this.fuelvehiclesData["datasets"][i]["data"].length;
              j++
            ) {
              this.fuelvehiclesData["datasets"][i]["data"][j] *= 1000;
            }
          }
          // this.areaChartData['datasets'][i]['label'] = "TEST";
        }
      }
    }

    // DEFINE Y LABEL WITH UNIT
    if (this.indicator == "energy") {
      var y_label_type = "Y_LABEL_NAME_IND_EN";
    } else if (this.indicator == "co2") {
      var y_label_type = "Y_LABEL_NAME_IND_CO2";
    }
    this.yAxeLabel_ind = this.translateService.instant(
      `DASHBOARD.CHARTS.${this.chart_id}.${y_label_type}`
    );
    this.yAxeLabel_amount = this.translateService.instant(
      `DASHBOARD.CHARTS.${this.chart_id}.Y_LABEL_NAME`
    );
    var amount_unit = this.helper.getNumberUnitIdFromFilterValue(
      this.chartData["value_type"] ? this.value_type : "absolute"
    );
    if (this.unit[this.indicator] == 'amount'){
      var unit_from_config = amount_unit;
    }
    else {
      var unit_from_config = this.helper.getUnitIdFromFilterValue(
        this.chartData["value_type"] ? this.value_type : "absolute",
        this.unit[this.indicator]
      );
    }
    if (this.chart_id == "mobility-fuel-vehicles-only-amount") {
      var main_unit = "various.";
    }
    else if (this.chart_id == "mobility-fuel-vehicles-absolute-energy") {
      var main_unit = "various.";
    }
    else {
      var main_unit = amount_unit["translate_unit"];
    }
    this.yAxeLabel_amount += this.translateService.instant(
      `UNITS.${main_unit}`
    );
    if (this.chart_id == "mobility-fuel-vehicles-absolute-energy") {
      var ind_unit = "energy.abs_kwh";
    }
    else {
      var ind_unit = unit_from_config["translate_unit"];
    }
    this.yAxeLabel_ind += this.translateService.instant(
      `UNITS.${ind_unit}`
    );
    if (this.chart_id == "mobility-fuel-vehicles-energy-ghg-bar"){
      if (this.indicator != "nb"){
        this.yAxeLabel_amount = this.yAxeLabel_ind;
      }
      this.localOptions.scales.yAxes[1]['display'] = false;
    }
    // Define behavior of tooltip for the chart
    this.localOptions.tooltips.callbacks.label = (item, data) => {
      let unit;
      let translate_var = this.value_type;
      if (this.chartData["value_type"] && this.value_type == "pourcent") {
        unit = "%";
      } else {
        if (data.datasets[item.datasetIndex]["yAxisID"] == "ind" || 
          this.chart_id == "mobility-fuel-vehicles-energy-ghg-bar") {
          if (this.indicator == "energy") {
            unit = "kWh";
          } else if (this.indicator == "co2") {
            unit = "tCO2";
          } else if (this.indicator == "nb") {
            unit = "véhic.";
            if (this.value_type == "habitant"){
              unit += "/ hab.";
            }
          }
          // this.translateService.instant("UNITS....)"
        } else if (data.datasets[item.datasetIndex]["yAxisID"] == "nb") {
          unit = "véhic.";
        }
        if (
          ((this.chartData["value_type"] &&
            unit_from_config["translate_unit"] == "energy.inhabitant_kwh") ||
          unit_from_config["translate_unit"] == "ghg.inhabitant_ton") &&
          this.chart_id != "mobility-fuel-vehicles-only-amount" &&
          this.chart_id != "mobility-fuel-vehicles-absolute-energy" 
        ) {
          unit += "/ hab.";
        }
      }
      /*  else {
        translate_var = unit + '.energy_absolute';
      } */

      return [
        `${data.datasets[item.datasetIndex].label} :`,
        `${this.helper.getThousandSeparatorFromNumber(item.yLabel)} ` + unit
      ];
    };
    // configure tooltip footer to display total values
    // don't display if not specified in configuration and for % (total will always be 100%)
    if (this.value_type != "pourcent" && this.totals_in_tooltip) {
      this.localOptions.tooltips.callbacks.footer = (item, data) => {
        // hovered data indices
        const datasetIndex = item[0].datasetIndex;
        const dataIndex = item[0].index;

        // don't display totals for line dataset
        if (this.fuelvehiclesData["datasets"][datasetIndex].yAxisID == "ind") {
          return [];
        }

        // raw values
        let total = this.fuelvehiclesData["datasets"][datasetIndex].totals[
          dataIndex
        ];
        let unit = "véhic.";

        // convert unit according to filter
        let unit_from_config = this.helper.getUnitIdFromFilterValue(
          this.chartData["value_type"] ? this.value_type : "absolute",
          this.unit[this.indicator]
        );
        if (
          ((this.chartData["value_type"] &&
            unit_from_config["translate_unit"] == "energy.inhabitant_kwh") ||
          unit_from_config["translate_unit"] == "ghg.inhabitant_ton") &&
          this.chart_id != "mobility-fuel-vehicles-only-amount" &&
          this.chart_id != "mobility-fuel-vehicles-absolute-energy" 
        ) {
          unit += "/ hab.";
        }

        // format values
        [total, unit] = this.helper.convertTooBigValue(total, unit);
        total = this.helper.getThousandSeparatorFromNumber(total);
        unit = this.translateService.instant(unit);
        const total_translation = this.translateService.instant(
          `DASHBOARD.CHARTS.${this.chart_id}.TOTAL_TOOLTIP`
        );

        return [total_translation, total + " " + unit];
      };
    } else {
      // disable the footer callback to not display the totals
      this.localOptions.tooltips.callbacks.footer = (item, data) => {
        return [];
      };
    }
    const ctx = this.canvas.nativeElement.getContext("2d");

    this.localOptions.scales.yAxes[0]["scaleLabel"] = {
      display: true,
      labelString: this.yAxeLabel_amount,
      fontColor: "black",
      fontSize: 14
    };
    this.localOptions.scales.yAxes[0]["ticks"] = {
      beginAtZero: true,
      callback: this.yAxisTicksCallback
    }    
    
    this.localOptions.scales.yAxes[1]["scaleLabel"] = {
      display: true,
      labelString: this.yAxeLabel_ind,
      fontColor: "black",
      fontSize: 14,
    };
    this.localOptions.scales.yAxes[1]["ticks"] = {
      beginAtZero: true,
      callback: this.yAxisTicksCallback
    }
    
    // If only data about numbers of cars remove the second y axis
    if (this.chart_id == "mobility-fuel-vehicles-only-amount" || this.hide_second_yaxis)  {
      this.localOptions.scales.yAxes[1]['display'] = false;
    }
    this.localOptions.scales.yAxes[0].stacked = true;
    this.localOptions.scales.xAxes = [
      {
        stacked: true
      }
    ];

    this.localOptions.responsive = true;
    this.localOptions.maintainAspectRatio = false;
    this.localOptions.legend.display = false;

    this.chart = new Chart(ctx, {
      type: this.type,
      data: this.fuelvehiclesData,
      options: this.localOptions
      // options: {
      //   responsive: true,
      //   scales: {
      //     yAxes: this.yAxes_def,
      //   }
      // }
    });
  }

  yAxisTicksCallback = value => {
    // add thousand separator where needed, and round values larger than 10
    return this.helper.getThousandSeparatorFromNumber(value);
  };

  resetChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = void 0;
    }
  }

  updateLegend() {
    this.legendItems = [];
    const clickable = this.chartData["clickable"];
    if (clickable != undefined) {
      this.clickable = clickable;
    }
    if (this.chart) {
      // legend element is corresponds to each dataset and its color
      this.chart.data.datasets.forEach(dataset => {
        const legendItem: LegendItem = {
          label: dataset.label,
          color: dataset.backgroundColor,
          borderColor: dataset.borderColor
            ? dataset.borderColor
            : dataset.backgroundColor,
          borderStyle: dataset.borderColor ? "solid" : "none",
          clicked: false,
          datasetIndices: []
        };

        this.legendItems.push(legendItem);
      });
    }
  }

  onLegendClick(legendIndex: number) {
    let clickedDataset = this.chart.data.datasets[legendIndex];
    clickedDataset.hidden = !clickedDataset.hidden;
    this.chart.update();
  }

  getSampleData() {
    let fuelvehiclesChartLabels = [2010, 2014, 2018];
    let totData = [9365, 10252, 9443];
    let gasolineData = [7500, 8000, 6500];
    let dieselData = [1850, 1950, 1940];
    let elecData = [15, 300, 1000];
    let gazData = [0, 2, 2];
    let h2Data = [0, 0, 1];

    var sampleData = {
      labels: fuelvehiclesChartLabels
    };
    if (!this.show_network_mix) {
      this.fuelvehiclesDatasets = [
        {
          label: "Total",
          data: totData,
          stack: "total",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "nb"
        },
        {
          label: "Essence",
          data: gasolineData,
          stack: "gasoline",
          backgroundColor: "rgba(51, 51, 0, 0.3)",
          borderColor: "rgba(51, 51, 0)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "nb"
        },
        {
          label: "Diesel",
          data: dieselData,
          stack: "diesel",
          backgroundColor: "rgba(102, 0, 0, 0.3)",
          borderColor: "rgba(102, 0, 0)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "nb"
        },
        {
          label: "Véhicules électriques",
          data: elecData,
          stack: "elec",
          backgroundColor: "rgba(51, 153, 255, 0.3)",
          borderColor: "rgba(51, 153, 255)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "nb"
        },
        {
          label: "Véhicules à gaz",
          data: gazData,
          stack: "gas",
          backgroundColor: "rgba(255, 153, 0, 0.3)",
          borderColor: "rgba(255, 153, 0)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "nb"
        },
        {
          label: "Véhicules à hydrogène",
          data: h2Data,
          stack: "h2",
          backgroundColor: "rgba(102, 204, 204, 0.3)",
          borderColor: "rgba(102, 204, 204)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "nb"
        }
      ];
    }
    sampleData["datasets"] = this.fuelvehiclesDatasets;
    return sampleData;
  }
}
